module.exports = __webpack_public_path__ + "img/gme-vs-retail-outstanding-shares-30d-avg.fc724d12.jpg";